<style lang="scss" scoped>
	.m-viewpoint {
		position: relative;
		width: 100%;
		height: 100%;
		overflow: hidden;
		background: url('../../assets/mobile/viewpoint-bg.png');
		background-size: 100% 100%;
		padding-top: 7vh;
	}
	.container {
		position: relative;
		margin-top: 15vh;
		width: 100%;
		overflow: hidden;
		text-align: center;
		.viewpoint-icon1 {
			position: absolute;
			top: 0;
			right: 10px;
			width: 13vh;
		}
		.viewpoint-icon2 {
			position: absolute;
			left: 10px;
			bottom: -18px;
			height: 8vh;
		}
		.viewpoint-animate1,
		.viewpoint-animate2 {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: auto;
		}
		.viewpoint-animate3 {
			width: 100%;
			height: auto;
		}
		.viewpoint-animate1{
			animation:animation1 40s linear infinite;
		}
		@keyframes animation1 {
			0%{ transform: rotate(0deg); }
			100%{ transform: rotate(360deg); }
		}
		.viewpoint-animate2 {
			animation:animation2 40s linear infinite;
		}
		@keyframes animation2 {
			0%{ transform: rotate(0deg); }
			100%{ transform: rotate(-360deg); }
		}
		.viewpoint-animate3 {
			animation:animation3 5s linear infinite;
		}
		@keyframes animation3 {
			0%{ opacity: 0; }
			20%{ opacity: 0.4; }
			40%{ opacity: 0.8; }
			70%{ opacity: 0.1; }
			80%{ opacity: 0.4; }
			100%{ opacity: 0; }
		}
		.content {
			position: absolute;
			top: 10%;
			left: 0;
			right: 0;
			margin: 0 auto;
			width: 80%;
		}
	}
</style>

<template>
<div class="m-viewpoint">
	<div class="container">
		<img class="viewpoint-icon1" src="../../assets/mobile/viewpoint-icon1.png" alt="">
		<img class="viewpoint-icon2" src="../../assets/mobile/viewpoint-icon2.png" alt="">
		<img class="viewpoint-animate1" src="../../assets/mobile/viewpoint-animate1.png" alt="">
		<img class="viewpoint-animate2" src="../../assets/mobile/viewpoint-animate2.png" alt="">
		<img class="viewpoint-animate3" src="../../assets/mobile/viewpoint-animate3.png" alt="">
		<img class="content" :src="image" alt="">
	</div>
</div>
</template>

<script>
export default {
	name: 'MViewpoint',
	data() {
		return {
			image: ''
		}
	},
	mounted() {
		const width = document.body.clientWidth;
		if(width > 850) {
			this.$router.push({name: 'p-viewpoint'});
		} else {
			this.init();
		}
	},
	methods: {
		init() {
			this.$http.get('/api/website/getWorldViewInfo?platform=2').then((rsp) => {
				if(rsp.result.worldView.length > 0) {
					this.image = rsp.result.worldView[0].filePath;
				}
			});
		}
	}
}
</script>